import React, { useState, useEffect } from "react";
import toast from 'react-hot-toast';
import useApi from '../../hooks/useApi';
import { IntakeForm, IntakeFormResponse } from '../rtm_plan/index.type';

const useAllIntakeForms = () => {
  const [intakeForms, setIntakeForms] = useState<IntakeForm[]>([]);
  
  const { loading: intakeFormsLoading, makeApiCall } = useApi({
    url: `/rtm/template/intakeForm`,
    method: 'GET',
  });
  
  const getIntakeFormsData = async () => {
    const { response, error } = await makeApiCall<undefined, IntakeFormResponse>();
    
    if (response?.status === 'success') {
      setIntakeForms(response.data);
      return response.data;
    }
    
    if (error) toast.error('Something went wrong while fetching intake forms. Please try again later');
    return [];
  };
  
  return {
    intakeForms,
    getIntakeFormsData,
    intakeFormsLoading,
  };
};

export default useAllIntakeForms;